const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() ?? "";
const ORG_ID_OVERRIDE_RAW = (import.meta.env.VITE_ORG_ID as string | undefined)?.trim() ?? "";
const ALLOW_ORG_OVERRIDE = import.meta.env.VITE_ALLOW_ORG_OVERRIDE === "true";

export const apiBaseUrl = API_BASE_URL;
export const hasApiBaseUrl = API_BASE_URL.length > 0;

export function getDevOrgOverride(): string | undefined {
  if (!ORG_ID_OVERRIDE_RAW) return undefined;

  if (import.meta.env.PROD) {
    return undefined;
  }

  if (import.meta.env.DEV || ALLOW_ORG_OVERRIDE) {
    return ORG_ID_OVERRIDE_RAW;
  }

  return undefined;
}

export function runRuntimeDiagnostics(): void {
  if (!hasApiBaseUrl) {
    console.error("Missing API configuration: VITE_API_BASE_URL.");
  }

  if (ORG_ID_OVERRIDE_RAW && import.meta.env.PROD) {
    console.warn("VITE_ORG_ID is set in production and will be ignored.");
  }
}
